var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCreateAiPrimaryLinear3232 = function SvgIconCreateAiPrimaryLinear3232(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-create-ai-primary-linear-32*32_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-primary-linear-32*32_svg__b)",
    d: "M.335 30.048a1.145 1.145 0 0 0 0 1.616c.445.446 1.17.446 1.616 0l3.392-3.392-1.616-1.616-3.392 3.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-primary-linear-32*32_svg__c)",
    d: "m26.416 12.964-1.5-2.011.805-2.376c.482-1.423-.877-2.782-2.3-2.3l-2.376.805-2.01-1.5c-1.206-.899-2.918-.025-2.9 1.477l.033 2.508-2.048 1.449c-1.227.868-.926 2.766.509 3.213l1.162.361-10.74 10.74 1.617 1.616 10.74-10.74c.379 1.222.412 1.49.776 1.875.764.806 2.12.756 2.798-.203l1.448-2.048 2.533.032c1.488 0 2.346-1.7 1.453-2.898Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-primary-linear-32*32_svg__d)",
    d: "M28.22 17.29a.937.937 0 1 0-1.326 1.326l.996.995a.937.937 0 1 0 1.325-1.325l-.995-.996Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-primary-linear-32*32_svg__e)",
    d: "M31.063 12.078h-1.408a.937.937 0 0 0 0 1.875h1.408a.937.937 0 0 0 0-1.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-primary-linear-32*32_svg__f)",
    d: "M22.622 19.11a.937.937 0 0 0-.937.937v1.408a.937.937 0 1 0 1.874 0v-1.408a.937.937 0 0 0-.937-.938Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-primary-linear-32*32_svg__g)",
    d: "M13.386 5.104a.937.937 0 1 0 1.326-1.326l-.996-.996a.937.937 0 1 0-1.325 1.326l.995.996Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-primary-linear-32*32_svg__h)",
    d: "M18.984 3.283c.517 0 .937-.42.937-.938V.937a.937.937 0 0 0-1.875 0v1.408c0 .518.42.938.938.938Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-primary-linear-32*32_svg__i)",
    d: "M10.543 10.312h1.408a.937.937 0 0 0 0-1.874h-1.408a.937.937 0 0 0 0 1.874Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-primary-linear-32*32_svg__b",
    x1: 2.118,
    x2: 3.279,
    y1: 28.512,
    y2: 33.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-primary-linear-32*32_svg__c",
    x1: 13.664,
    x2: 18.386,
    y1: 12.767,
    y2: 31.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-primary-linear-32*32_svg__d",
    x1: 27.757,
    x2: 28.381,
    y1: 18.013,
    y2: 20.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-primary-linear-32*32_svg__e",
    x1: 30.019,
    x2: 30.262,
    y1: 12.729,
    y2: 14.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-primary-linear-32*32_svg__f",
    x1: 22.428,
    x2: 23.537,
    y1: 20.25,
    y2: 22.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-primary-linear-32*32_svg__g",
    x1: 13.254,
    x2: 13.878,
    y1: 3.505,
    y2: 5.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-primary-linear-32*32_svg__h",
    x1: 18.79,
    x2: 19.898,
    y1: 1.14,
    y2: 3.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-primary-linear-32*32_svg__i",
    x1: 10.907,
    x2: 11.15,
    y1: 9.089,
    y2: 10.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-create-ai-primary-linear-32*32_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgIconCreateAiPrimaryLinear3232;